const en = {
  add_user_agreement:
    "I understand that adding user licenses might result in additional charges, depending on the terms outlined in my contract.",
  "custom.auth.cta_href": "https://www.ibexa.co/products/ibexa-cloud",
  "custom.auth.cta_text": "Learn more",
  "custom.auth.description": "Discover all capabilities of Ibexa Cloud",
  "custom.auth.footer_text": "Ibexa Cloud is powered by Upsun",
  "custom.auth.hero_text": "Ibexa Cloud",
  "footer.message": "Version {appVersion} - Ibexa Cloud",
  no_credit_card_signup: "Register for free",
  "setup.cli.install.code": "curl -sfS https://cli.ibexa.cloud/installer | php",
  "setup.cli.install.label": "Install CLI",
  try_us_for_free: "Create your account",
  "url.logo_url": "https://www.ibexa.co/"
};

export default en;
